import React, { useState } from "react";

import AppBar from "@material-ui/core/AppBar";
import Tabs from "@material-ui/core/Tabs";
import Tab from "@material-ui/core/Tab";

import { TabAsuransi, TabPerusahaan } from "./ui";
import { TabPanel, useTabStyle } from "App/Component/ui";
import "./style.scss";
function a11yProps(index) {
  return {
    id: `tab-panel-${index}`,
    "aria-controls": `TabPanel-${index}`,
  };
}

export default function JenisAsuransi() {
  const classes = useTabStyle();
  const [value, setValue] = useState(0);

  const handleChange = (event, newValue) => {
    setValue(newValue);
  };

  return (
    <div className={classes.root}>
      <div className={classes.rootTab}>
        <AppBar
          position='static'
          classes={{
            root: classes.appbar,
          }}>
          <Tabs
            value={value}
            onChange={handleChange}
            variant='fullWidth'
            aria-label='Tabs Jenis Asuransi'
            classes={{
              root: classes.tabs,
              flexContainer: classes.fixedTab,
            }}>
            <Tab
              classes={{
                selected: classes.selected,
                fullWidth: classes.tab,
              }}
              label='ASURANSI'
              {...a11yProps(0)}
            />
            <Tab
              classes={{
                selected: classes.selected,
                fullWidth: classes.tab,
              }}
              label='PERUSAHAAN'
              {...a11yProps(1)}
            />
            {/* <Tab
              classes={{
                selected: {
                  backgroundColor: PRIMARY_COLOR_BUTTON,
                  color: "white",
                },
                fullWidth: {
                  border: `1px solid ${PRIMARY_COLOR_BUTTON}`,
                },
              }}
              label='BPJS & Umum'
              {...a11yProps(2)}
            /> */}
          </Tabs>
        </AppBar>
        <TabPanel value={value} index={0}>
          <TabAsuransi />
        </TabPanel>
        <TabPanel value={value} index={1}>
          <TabPerusahaan />
        </TabPanel>
        {/* <TabPanel value={value} index={2}>
          <TabBpjsUmum />
        </TabPanel> */}
      </div>
    </div>
  );
}
